import React, { lazy, Suspense } from "react";
import { Switch } from "react-router-dom";
import Spinner from "../components/Spinner";
import PublicRoute from "../services/PublicRoute";

const AboutUs = lazy(() => import("../screens/public/AboutUs"));
const AirtimePage = lazy(() => import("../screens/public/AirtimePage"));
const AirtimePayPage = lazy(() => import("../screens/public/AirtimePayPage"));
const CablePage = lazy(() => import("../screens/public/CablePage"));
const CablePayPage = lazy(() => import("../screens/public/CablePayPage"));
const ContactPage = lazy(() => import("../screens/public/ContactPage"));
const DataPage = lazy(() => import("../screens/public/DataPage"));
const DataPayPage = lazy(() => import("../screens/public/DataPayPage"));
const FeaturesPage = lazy(() => import("../screens/public/FeaturesPage"));
const HomePage = lazy(() => import("../screens/public/HomePage"));
const PowerPage = lazy(() => import("../screens/public/PowerPage"));
const PowerPayPage = lazy(() => import("../screens/public/PowerPayPage"));

const Public = props => {
	return (
		<Suspense fallback={<Spinner />}>
			<Switch>
        <PublicRoute exact path="/" component={HomePage} />
				<PublicRoute exact path="/about-us" component={AboutUs} />
				<PublicRoute exact path="/features" component={FeaturesPage} />
				<PublicRoute exact path="/contact" component={ContactPage} />
				<PublicRoute exact path="/airtime" component={AirtimePage} />
				<PublicRoute exact path="/data" component={DataPage} />
				<PublicRoute exact path="/power" component={PowerPage} />
				<PublicRoute exact path="/cable" component={CablePage} />
				<PublicRoute
					exact
					path="/airtime/:provider"
					component={AirtimePayPage}
				/>
				<PublicRoute exact path="/data/:provider" component={DataPayPage} />
				<PublicRoute exact path="/power/:provider" component={PowerPayPage} />
				<PublicRoute exact path="/cable/:provider" component={CablePayPage} />
			</Switch>
		</Suspense>
	);
};

export default Public;
